import React from 'react';
import classNames from 'classnames';
import './Loader.less';

interface LoaderPropsInterface {
  spinning: boolean;
  fullScreen?: boolean;
}

export const Loader: React.FC<LoaderPropsInterface> = ({ spinning = false, fullScreen = false }) => {
  return (
    <div
      className={classNames('loader', {
        hidden: !spinning,
        fullScreen
      })}
    >
      <div className="warpper">
        <div className="inner" />
        <div className="text">LOADING</div>
      </div>
    </div>
  );
};
